/* eslint-disable no-param-reassign */
function isNumeric(n) {
  return !Number.isNaN(parseFloat(n)) && Number.isFinite(n);
}

const gray = (lightness, hue = 0, darkBackground = false) => {
  // Convert named hues into numeric lightness value.
  if (hue === 'cool') {
    hue = 237;
  } else if (hue === 'slate') {
    hue = 122;
  } else if (hue === 'warm') {
    hue = 69;
  }

  if (!isNumeric(hue)) {
    throw new Error('Hue is not a number');
  }

  if (!isNumeric(lightness)) {
    throw new Error('Lightness is not a number');
  }

  if (lightness > 100) {
    lightness = 100;
  }

  if (lightness < 0) {
    lightness = 0;
  }

  let saturation = 0;
  let opacity = 0;

  if (hue !== 0) {
    const a = 19.92978;
    const b = -0.3651759;
    const c = 0.001737214;
    saturation = a + b * lightness + c * Math.pow(lightness, 2); // eslint-disable-line
    lightness = `${lightness}%`;
    opacity = 1;
  } else if (darkBackground) {
    opacity = lightness / 100;
    lightness = '100%';
  } else {
    opacity = (100 - lightness) / 100;
    lightness = '0%';
  }

  return `hsla(${hue}, ${saturation}%, ${lightness}, ${opacity})`;
};

export default gray;



// WEBPACK FOOTER //
// ./src/utils/gray.js